import { render, staticRenderFns } from "./ContaView.vue?vue&type=template&id=26899b35&scoped=true&"
import script from "./ContaView.vue?vue&type=script&lang=js&"
export * from "./ContaView.vue?vue&type=script&lang=js&"
import style0 from "./ContaView.vue?vue&type=style&index=0&id=26899b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26899b35",
  null
  
)

export default component.exports